<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'

const emit = defineEmits<{
  /** Emitted when close button is clicked */
  close: []
}>()

defineOptions({
  name: 'EntryDetailsPanelClose'
})

const store = useStore()

const isDesktop = computed<boolean>(() => store.getters['app/isLg'])

const { t } = useI18n()
</script>

<template>
  <div class="flex flex-row py-4 lg:justify-end">
    <button
      class="inline-flex items-center border-0 bg-transparent"
      type="button"
      :aria-label="t('general.close')"
      @click="emit('close')"
    >
      <span
        class="inline-flex items-center rounded-full border border-transparent bg-secondary-200 p-2 leading-normal text-secondary-600"
      >
        <VIcon
          :icon="isDesktop ? '$close' : '$chevron-left'"
          size="small"
          class="text-secondary-900"
        />
      </span>
      <span v-if="!isDesktop" class="ml-2 inline-flex">
        <slot />
      </span>
    </button>
  </div>
</template>
